import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/RegionalInternship.css';

const RegionalInternship: React.FC = () => {
  const desktopImagePath = '/assets/Web Version/Our Success Stories/regional-internship-programs-image.png';
  const mobileImagePath = '/assets/Web Version/Our Success Stories/mobile/regional-internship-programs-image-mob.png';
  
  return (
    <div className="regional-internship-page">
      <div className="regional-internship-hero-banner">
        <div 
          className="regional-internship-hero-background"
          style={{ 
            backgroundImage: `url("${desktopImagePath}")` 
          }}
        ></div>
        <div 
          className="regional-internship-hero-background-mobile"
          style={{ 
            backgroundImage: `url("${mobileImagePath}")` 
          }}
        ></div>
        <div className="regional-internship-hero-content">
          <div className="regional-internship-breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-separator">/</span>
            <Link to="/news-and-insights">News & Insights</Link>
            <span className="breadcrumb-separator">/</span>
            <Link to="/news-and-insights/our-success-stories">Our Success Stories</Link>
          </div>
          <h1 className="regional-internship-title">
            Regional Internship Programs – Improving Job Conversions and Strengthening Employer Engagement
          </h1>
        </div>
      </div>

      {/* Content Sections */}
      <div className="regional-internship-content">
        {/* Overview Section */}
        <div className="regional-internship-section">
          <h2 className="regional-internship-section-title">Overview</h2>
          <p className="regional-internship-section-text">
            Recognizing the growing need to connect academic institutions, students, and employers in a more meaningful way, we partnered with regional universities and corporate partners to design and launch a comprehensive <strong>Regional Internship Program</strong>. The program bridges classroom learning with hands-on professional experience—helping students build job-ready skills while enabling employers to access a pre-vetted, motivated talent pool aligned with their business needs.
          </p>
        </div>

        {/* Objective Section */}
        <div className="regional-internship-section">
          <h2 className="regional-internship-section-title">Objective</h2>
          <p className="regional-internship-section-text">
            To enhance <strong>employability outcomes</strong> for students and drive <strong>sustainable partnerships</strong> between universities and regional employers—ultimately converting internships into long-term career placements.
          </p>
        </div>

        {/* Execution Section */}
        <div className="regional-internship-section">
          <h2 className="regional-internship-section-title">Execution</h2>
          <p className="regional-internship-section-text">
            Our engagement involved a structured, multi-phase approach:
          </p>
          <ul className="regional-internship-list">
            <li><strong>Program Design:</strong> Defined internship frameworks that matched academic competencies with industry demand across multiple disciplines.</li>
            <li><strong>Employer Partnerships:</strong> Onboarded regional employers from healthcare, technology, finance, and public sector domains to participate in mentorship and project-based internships.</li>
            <li><strong>University Collaboration:</strong> Coordinated with university career centers and faculty to integrate internships into credit-based learning programs.</li>
            <li><strong>Student Readiness:</strong> Conducted workshops on professional skills, digital tools, and workplace readiness to improve conversion potential.</li>
            <li><strong>Tracking & Evaluation:</strong> Implemented data-driven dashboards to monitor participation, completion rates, and post-internship employment outcomes.</li>
          </ul>
        </div>

        {/* Key Achievements Section */}
        <div className="regional-internship-section">
          <h2 className="regional-internship-section-title">Key Achievements</h2>
          <ul className="regional-internship-list">
            <li>Achieved a <strong>35% increase in internship-to-employment conversions</strong> across participating universities.</li>
            <li>Expanded employer participation by <strong>over 40%</strong> through improved engagement strategies and feedback mechanisms.</li>
            <li>Enabled <strong>cross-institutional collaboration</strong>, sharing resources and internship models that improved scalability and quality.</li>
            <li>Launched a <strong>career readiness framework</strong> adopted by multiple regional universities as a best-practice model.</li>
            <li>Fostered long-term partnerships between academia and industry, creating a recurring pipeline of skilled, job-ready graduates.</li>
          </ul>
        </div>

        {/* Impact Section */}
        <div className="regional-internship-section">
          <h2 className="regional-internship-section-title">Impact</h2>
          <p className="regional-internship-section-text">
            This initiative has:
          </p>
          <ul className="regional-internship-list">
            <li>Strengthened the regional workforce by connecting local talent to local opportunities.</li>
            <li>Enhanced universities' placement metrics and employer satisfaction.</li>
            <li>Provided a replicable model for other academic networks seeking to boost student employability and corporate engagement.</li>
          </ul>
        </div>
      </div>

      {/* Looking Ahead Section */}
      <div className="regional-looking-ahead">
        <h2 className="regional-looking-ahead-title">Looking Ahead</h2>
        <p className="regional-looking-ahead-description">
          Building on this success, we are expanding the <strong>Regional Internship Consortium</strong> to new regions and industries—integrating AI-based career analytics and mentorship tools to further personalize student–employer matching.
        </p>
      </div>
    </div>
  );
};

export default RegionalInternship;

